// Quiz upsell ATC Functionality
if (!customElements.get('quiz-upsell-items-greens')) {
  class QuizUpsellItems extends HTMLElement {

    constructor() {
      super();

      this.prod = this.dataset.prod;
      this.prodPlan = this.dataset.prodPlan;
      this.subscriptionUpsellPlan = this.dataset.subscriptionUpsellPlan;
      this.subscriptionDiscountPercentage = this.dataset.subscriptionDiscountPercentage;
      this.upsell = this.dataset.upsell;
      this.upsellProdOff = this.dataset.upsellProdOff;
      this.upsellFree = this.dataset.upsellFree;
      this.upsellFreeTwo = this.dataset.upsellFreeTwo;
      this.applyFreeShipping = this.dataset.applyFreeShipping;
      this.planTime = this.dataset.planTime;
      this.quantity = this.dataset.quantity;
      this.oneMonthPlan = this.dataset.oneMonthPlan;
      this.threeMonthPlan = this.dataset.threeMonthPlan;

      this.atcButton = this.querySelector('[data-quiz-greens-upsell-atc]');

      document.querySelectorAll('[data-quiz-greens-upsell-atc]').forEach(button => {
        if (button !== this.atcButton) {
          button.innerHTML = this.atcButton.innerHTML;
        }
      });

      this.fetchConfig = fetchConfig('javascript');
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.handleClickBind = this.handleClick.bind(this);
    }

    connectedCallback() {
      window.addEventListener('click', this.handleClickBind);
    }

    addButtonAttributes() {
      document.querySelectorAll('[data-quiz-greens-upsell-atc], [data-quiz-greens-regular-atc]').forEach(button => {  
        button.setAttribute("disabled", "disabled");  
        button.classList.add('active');  
      });  
    }
    removeButtonAttributes() {
      document.querySelectorAll('[data-quiz-greens-upsell-atc], [data-quiz-greens-regular-atc]').forEach(button => {  
        button.removeAttribute("disabled");
        button.classList.remove('active');
      });  
    }

    handleClick(evt) {
      const upsellATCButton = evt.target.closest('[data-quiz-greens-upsell-atc]');
      const regularATCButton = evt.target.closest('[data-quiz-greens-regular-atc]');
      if (upsellATCButton) {
        this.upsellATC(true);
      } else if (regularATCButton) {
        this.upsellATC(false);
      }
    }

    // Method for Criteo tracking, which returns a Promise
    criteoTracking(itemArray, data) {
      return new Promise((resolve, reject) => {
        try {
          // Retrieve email from localStorage
          const quizUserEmail = localStorage.getItem("quizUserEmail") || "";
          //console.log('Item added to cart:', data); // Log the added item data

          window.criteo_q = window.criteo_q || [];
          const deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";

          // Prepare the items array for Criteo, mapping over itemArray to get variants
          const itemsToTrack = itemArray.map((item, index) => {
            return {
              id: item.id,  // Variant ID, not product ID
              price: Shopify.formatMoney(data.items[index].final_price),  // Access the final_price from data.items -  final price is caculated after all discounts
              quantity: item.quantity  // Quantity of the variant being added
            };
          });

          window.criteo_q.push(
            { event: "setAccount", account: 84368 },
            { event: "setEmail", email: quizUserEmail, hash_method: "sha256" },
            { event: "setEmail", email: quizUserEmail, hash_method: "md5" },
            { event: "setSiteType", type: deviceType },
            { event: "setZipcode", zipcode: this.zipCode },
            { event: "addToCart", item: itemsToTrack }
          );

          console.log(itemsToTrack);  

          // Resolve promise after the tag is fired
          resolve("Criteo Tag Fired Successfully");
        } catch (error) {
          console.error("Error in Criteo Tag:", error);
          reject(error);  // Reject the promise in case of any error
        }
      });
    }


    upsellATC(upgradeOrder) {
      const itemArray = [];


      
      if (upgradeOrder) {


        if (this.prod && this.prod !== '') {
          const upsellItem = {
            quantity: this.quantity,
            id: this.prod,
            selling_plan: this.subscriptionUpsellPlan
          };

          upsellItem.properties = {
            _quiz_upsell_greens: this.planTime
          }
          itemArray.push(upsellItem);
        }


        if (this.upsell && this.upsell !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsell,
          };
          
          upsellItem.properties = {
            _quiz_upsell_greens: this.planTime
          }
          itemArray.push(upsellItem);
        }


        if (this.upsellFree && this.upsellFree !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsellFree
          };

          upsellItem.properties = {
            _quiz_upsell_greens: this.planTime
          }
          itemArray.push(upsellItem);
        }


        if (this.upsellFreeTwo && this.upsellFreeTwo !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsellFreeTwo
          };

          upsellItem.properties = {
            _quiz_upsell_greens: this.planTime
          }
          itemArray.push(upsellItem);
        }

      } else {
        if (this.prod && this.prod !== '' && this.oneMonthPlan == 'true') {
          const upsellItem = {
            quantity: 1,
            id: this.prod,
            selling_plan: this.prodPlan,
          };

          upsellItem.properties = {
            _quiz_upsell_greens: this.planTime
          }
          itemArray.push(upsellItem);
        } else {
          const upsellItem = {
            quantity: this.quantity,
            id: this.prod,
            selling_plan: this.prodPlan,
          };

          upsellItem.properties = {
            _quiz_upsell_greens: this.planTime
          }
          itemArray.push(upsellItem);
        }

        // One month plan
        if (this.oneMonthPlan == 'true') { 
          if (this.upsellFree && this.upsellFree !== '') {
            const upsellItem = {
              quantity: 1,
              id: this.upsellFree
            };
  
            upsellItem.properties = {
              _quiz_upsell_greens: this.planTime
            }
            itemArray.push(upsellItem);
          }
        }

        // Three months plan
        if (this.threeMonthPlan == 'true') { 
          if (this.upsellFreeTwo && this.upsellFreeTwo !== '') {
            const upsellItem = {
              quantity: 1,
              id: this.upsellFreeTwo
            };
  
            upsellItem.properties = {
              _quiz_upsell_greens: this.planTime
            }
            itemArray.push(upsellItem);
          }
        }

        
      }




      if (itemArray.length > 0) {
        this.atc(itemArray);
      }
    }

    atc(itemArray) {
      document.body.classList.add('hide-upcart');
      this.fetchConfig.body = JSON.stringify({ 'items': itemArray });

      this.addButtonAttributes();

      fetch(routes.cart_add_url, this.fetchConfig)
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse the response JSON
          } else {
            throw new Error('Failed to add item to cart');
          }
        })
        .then((data) => {
          // Call criteoTracking and wait for it to resolve before redirecting
          this.criteoTracking(itemArray, data)
            .then(() => {
              console.log("Redirecting to checkout...");
               window.location.href = '/checkout';  // Redirect after Criteo tracking
            })
            .catch((error) => {
              this.removeButtonAttributes();
              console.error("Criteo Tracking failed, proceeding to checkout:", error);
              window.location.href = '/checkout';  // Redirect even if Criteo tracking fails
            });
        })
        .catch((error) => {
          console.error('Error:', error);
          document.body.classList.remove('hide-upcart');
        });
    }

  }
  customElements.define('quiz-upsell-items-greens', QuizUpsellItems);
}